<template>
  <div class="content">
    <div class="head-body">
      <div class="head-logo">
        <img src="../assets/logo_name.png" alt="">
      </div>
      <div class="head-search-body">
        <div class="head-search">
          <div class="search-ic">
            <img src="../assets/ic_search.png" alt="">
          </div>
          <div class="search-text">
            <input type="text" placeholder="搜索网盘文件" v-model="searchInputValue" @keyup.enter="search">
            <div class="ic-clean" v-if="searchInputValue.length > 0" @click="cleanSearchValue">
              <img src="@/assets/ic_clean.png" alt="clean" />
            </div>
          </div>
        </div>
        <!-- <div class="head-open-member-body" @mouseenter="showOpenMember" @mouseleave="hideOpenMember">
          开通会员
          <div class="head-open-member-bar">
            限时优惠
          </div>
        </div>
        <div v-if="isOpenMemberHovered || isOpenMemberHoveredTemp"
          @mouseenter="showTempOpenMember" @mouseleave="hideTempOpenMember"
          class="open-member-hover-display"
          :style="{ top: openMemberPosition.top + 'px', left: openMemberPosition.left + 'px' }">
          <slot>
            <div class="open-member-body">
              <div class="open-member-head" :class="{ 'bg-normal': userVipInfo.vip_status == 0, 'bg-active': userVipInfo.vip_status == 1 }">
                <div class="open-member-head-msg">
                  <div class="open-member-head-name">
                    <img src="@/assets/member_name.png" alt="">
                  </div>
                  <div class="open-member-head-tips" :class="{'tips-vip': userVipInfo.vip_status == 1}">
                    {{ userVipInfo.vip_status == 0 ? '你还不是快兔会员，无法享受会员权益' : '会员有效期至 ' + userVipInfo.vip_info.time_end }}
                  </div>
                </div>
              </div>
              <div class="open-member-title">
                开通会员立享专属权益
              </div>
              <div class="member-options-grid">
                <div class="option-item" v-for="(item, index) in memberOptions" :key="index">
                  <div class="option-icon">
                    <img :src="item.icon" :alt="item.title">
                  </div>
                  <div class="option-title">{{ item.title }}</div>
                </div>
              </div>
              <div class="open-member-body-btn" @click="showOpenMemberDialog">
                {{ userVipInfo.vip_status == 0 ? '立即开通' : '立即续费' }}
              </div>
            </div>
          </slot>
        </div> -->
        <div class="head-download-body" @mouseenter="showQrCode" @mouseleave="hideQrCode">
          <img src="../assets/ic_download.png" alt="">
        </div>
        <div v-if="isHovered"
          class="hover-display"
          :style="{ top: position.top + 'px', left: position.left + 'px' }">
          <slot>
            <div class="download-body">
              <div class="title">扫码下载</div>
              <div class="app-name">快兔APP</div>
              <QrcodeGenerator
                :text="qrCodeText"
                :size="131"
                :options="{ color: { dark: '#000000', light: '#ffffff' } }"
              />
            </div>
          </slot>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="left-tab">
        <div class="user-info">
          <div class="user-info-body">
            <div class="user-img">
              <img :src="userInfo.avatar" />
            </div>
            <div class="user-msg-body">
              <div class="user-name-body">
                <div class="user-name">
                  {{ userInfo.nickname }}
                </div>
                <div class="user-vip" v-if="userInfo.vip_status == 1">
                  <img src="../assets/ic_vip.png" alt="" />
                </div>
              </div>
              <div class="progress-container">
                <div class="progress-bar">
                  <div class="progress" :style="{ width: userVipInfo.vip_info.used_rate + '%' }">
                  </div>
                </div>
              </div>
              <div class="user-capacity-body">
                <div class="user-capacity">
                  {{ userVipInfo.vip_info.use_space }}{{ userVipInfo.vip_info.use_space_unit }} /
                  {{ userVipInfo.vip_info.max_space }}{{ userVipInfo.vip_info.max_space_unit }}
                </div>
                <!-- <div class="see-capacity">查看</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="tab-body">
          <div class="tab-item" @click="changeTab(index)" :class="{'item-selected': index == tabIndex}"
            v-for="(item, index) in tabs" :key="index">
            <div class="item-icon">
              <img :src="index === tabIndex ? item.iconSelected : item.icon" />
            </div>
            <div class="item-label">{{ item.label }}</div>
          </div>
        </div>
        <div class="log-out">
          <div class="log-out-btn" @click="logOut">
            退出登录
          </div>
        </div>
      </div>
      <div class="body">
        <div class="body-head-content">
          <div class="body-head">
            <div class="option-btns">
              <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" multiple>
              <div class="btn add" @click="selectedFile" v-if="userVipInfo.role_type === 2">上传文件</div>
              <div class="btn create" @click="createDirOpen">新建文件夹</div>
            </div>
            <div class="option-file-btns" v-if="tabIndex != 1 && tabIndex != 6 && tabIndex != 7">
              <div class="file-btn" v-if="item.isVisible" :class="{'last-file-btn': index+1 == optionFileBtns.length, 'btn-display': item.display}" v-for="(item, index) in optionFileBtns" :key="index" @click="optionFun(item.type)">
                {{ item.label }}
              </div>
            </div>
            <div class="option-file-btns" v-if="tabIndex == 6">
              <div class="file-btn" :class="{'last-file-btn': index+1 == recycleBtns.length, 'btn-display': item.display}" v-for="(item, index) in recycleBtns" :key="index" @click="recycleOptionFun(item.type)">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content">
          <component
            ref="tabChild"
            @selectionList="selectionList"
            @changeRecycleSelectedData="changeRecycleSelectedData"
            @cleanRecycleDisplay="cleanRecycleDisplay"
            @changeDirId="changeDirId"
            :search-value="searchValue"
            :is="currentTabComponent"
            :key="tabIndex"
            v-bind="currentTabProps"
          />
        </div>
      </div>
    </div>
    <div class="copyright">
      Copyright © 2024 深圳市寻讯科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer"> 粤ICP备2024291999号</a>
    </div>
    <UploadProgressDialog
      :isVisible="isUploadModalVisible"
      :uploadTaskList="uploadTaskList"
      @pauseUpload="pauseUpload"
      @resumeUpload="resumeUpload"
      @update:isVisible="isUploadModalVisible = $event"
    />

    <CreateDirDialog
      :isVisible="isOpenCreateVisible"
      :editFile="editFile"
      :title="createVisibleTitle"
      @update:isVisible="isOpenCreateVisible = $event"
      @submitCreateDir="submitCreateDir"
      @submitRename="submitRename"
    />

    <DirListDialog
      :isVisible="isDirListVisible"
      :selectionFile="selectionFile"
      @update:isVisible="isDirListVisible = $event"
      @reloadFiles="reloadFiles"
    />
    
    <OpenMemberDialog 
      :isVisible="isOpenMemberVisible" 
      :userVipInfo="userVipInfo"
      @update:isVisible="isOpenMemberVisible = $event" 
    />

  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import {
    userVip,
    diskPreUpload,
    diskStartTask,
    diskUpload,
    diskAddDir,
    dirFiles,
    diskDetail,
    diskDelFile,
    diskRenameFile,
    diskCodeCreate,
    recycleReduction,
    recycleDels,
    createMinioDownload,
    createMinioUpLoad,
    completeMinioUpLoad,
    completeMinioDownload,
    queryMinioAuth,
    getPreviewUrl
  } from '../utils/api/apis.js'

  // 从 minioApis.js 导入下载方法
  import { downloadMinioFile, 
    uploadMinioFile, 
    uploadMinioFileNew,
    initResumableUpload,
    uploadChunk,
    completeResumableUpload,
    getResumableProgress,
    initMinioDownload, 
    getMinioDownloadUrl
  } from '../utils/api/minioApis.js'

  import {
    ossUploadFile,
    ossPauseUpload,
    ossResumeUpload,
    ossDownloadFile
  } from '@/utils/oss.js'
  import tabFile from '@/components/tabs/tab_file.vue'
  import tabCommand from '@/components/tabs/tab_command.vue'
  import tabMember from '@/components/tabs/tab_member.vue'
  import tabRecycle from '@/components/tabs/tab_recycle.vue'
  import {
    calculateFileHash
  } from '@/utils/file_hash.js'
  import OSS from 'ali-oss';
  import UploadProgressDialog from '@/components/upload_progress_dialog.vue';
  import QrcodeGenerator from '@/components/qrcode_generator.vue';
  import CreateDirDialog from '@/components/create_dir_dialog.vue';
  import DirListDialog from '@/components/dir_list_dialog.vue';
  import { pauseUpload } from '../utils/oss.js'
  import { LocalStorageKeys } from '@/utils/local_storage';
  import { rsaDecryptWithPrivateKey } from '@/utils/sign_utils.js';
  import { forEach } from 'lodash'
  import { memberOptions } from '@/utils/member-options.js'
  import OpenMemberDialog from '@/components/open_member_dialog.vue';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      tabFile,
      tabCommand,
      tabMember,
      tabRecycle,
      UploadProgressDialog,
      CreateDirDialog,
      DirListDialog,
      QrcodeGenerator,
      OpenMemberDialog
    },
    data() {
      // 这里存放数据
      return {
        searchValue: '',
        searchInputValue: '',
        userInfo: {
          avatar: ''
        },
        userVipInfo: {
          vip_info: {
            time_begin: "",
            time_end: "",
            code_nums: 0,
            max_space: "",
            max_space_unit: "",
            use_space: 0,
            use_space_unit: "",
            used_rate: "",
            used_rate2: ""
          },
          config_info: {
            max_task_download: 0,
            max_task_upload: 0,
          }
        },
        // 0 下载，1 分享，2 删除，3 重命名，4 移动
        optionFileBtns: [{
            type: 0,
            label: '下载',
            display: true,
            isVisible: false
          },
          {
            type: 1,
            label: '分享',
            display: true,
            isVisible: true
          },
          {
            type: 2,
            label: '删除',
            display: true,
            isVisible: true
          },
          {
            type: 3,
            label: '重命名',
            display: true,
            isVisible: true
          },
          {
            type: 4,
            label: '移动到...',
            display: true,
            isVisible: true
          }
        ],
        recycleBtns: [{
            type: 0,
            label: '还原',
            display: true,
            icon: require('@/assets/ic_restore.png')
          },
          {
            type: 1,
            label: '删除',
            display: true,
            icon: require('@/assets/ic_del.png')
          },
          {
            type: 2,
            label: '清空',
            display: true,
            icon: require('@/assets/ic_clean_all.png')
          }
        ],
        tabIndex: 0,
        tabs: [{
            icon: require('../assets/tab_file_n.png'),
            iconSelected: require('../assets/tab_file_y.png'),
            label: '全部文件',
            component: 'tabFile',
            type: ''
          },
          {
            icon: require('../assets/tab_command_n.png'),
            iconSelected: require('../assets/tab_command_y.png'),
            label: '口令',
            component: 'tabCommand',
            type: 'command'
          },
          {
            icon: require('../assets/tab_zip_n.png'),
            iconSelected: require('../assets/tab_zip_y.png'),
            label: '压缩包',
            component: 'tabFile',
            type: '8'
          },
          {
            icon: require('../assets/tab_video_n.png'),
            iconSelected: require('../assets/tab_video_y.png'),
            label: '视频',
            component: 'tabFile',
            type: '2'
          },
          {
            icon: require('../assets/tab_img_n.png'),
            iconSelected: require('../assets/tab_img_y.png'),
            label: '图片',
            component: 'tabFile',
            type: '1'
          },
          {
            icon: require('../assets/tab_doc_n.png'),
            iconSelected: require('../assets/tab_doc_y.png'),
            label: '文档',
            component: 'tabFile',
            type: '99'
          },
          // {
          //   icon: require('../assets/tab_io_n.png'),
          //   iconSelected: require('../assets/tab_io_y.png'),
          //   label: '传送',
          //   component: 'tabIo',
          //   type: 'io'
          // },
          // {
          //   icon: require('../assets/tab_member_n.png'),
          //   iconSelected: require('../assets/tab_member_y.png'),
          //   label: '会员',
          //   component: 'tabMember',
          //   type: 'member',
          // },
          {
            icon: require('../assets/tab_recycle_n.png'),
            iconSelected: require('../assets/tab_recycle_y.png'),
            label: '回收站',
            component: 'tabRecycle',
            type: 'recycle',
          }
        ],
        dirId: 0,
        isUploadModalVisible: false,
        uploadTaskList: [],
        isOpenCreateVisible: false,
        createVisibleTitle: '新建文件夹',
        editFile: {
          id: 0,
          name: ''
        },
        selectionFile: [],
        isDirListVisible: false,
        isHovered: false,
        position: { top: 0, left: 0 },
        isOpenMemberHovered: false,
        isOpenMemberHoveredTemp: false,
        openMemberPosition: { top: 0, left: 0 },
        qrCodeText: process.env.VUE_APP_WEB_URL,
        recycleAllData: null,
        recycleSelectedData: null,
        memberOptions,
        isOpenMemberVisible: false
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {
      currentTabComponent() {
        return this.tabs[this.tabIndex].component;
      },
      currentTabProps() {
        if (this.currentTabComponent === "tabFile") {
          return {
            type: this.tabs[this.tabIndex].type,
            searchValue: this.searchValue.trim()
          };
        }
        return {};
      },
    },
    // 监控data中的数据变化
    watch: {
      // 监听上传队列，控制并行
      uploadTaskList: {
        handler(newVal, oldVal) {
          this.uploadFileTask()
        }
      }
    },
    // 方法集合
    methods: {
      getPreviewUrl(file_id) {
        const params = {
          "file_id": file_id
        }
        queryMinioAuth(params)

      },
      async queryMinioAuth(method, url) {
        const postData = {
          "method": method,
          "url_path": url
        }
        const response = await queryMinioAuth(postData)

        if (response.code === 200) {
            return response.data
          } else {
            this.$toast(response.msg || '获取签名信息失败');
            return null
          }
      },
      async miniDownload(fileId, fileName) {
        try {
          this.$dialog.loading.show();
          
          // 获取下载地址和认证参数
          const postData = {
            file_data: {
              id: fileId || '1029699'
            }
          };
          
          const response = await createMinioDownload(postData);
          
          if (response.code === 200) {
            const { download_url, signature_info } = response.data;
            
            // 🔑 关键改动：直接用带认证信息的完整URL打开
            // 构建带查询参数的 URL
            const urlParams = new URLSearchParams({
              'Authorization': signature_info.authorization,
              'X-app-id': signature_info['x-app-id'],
              'X-user-id': signature_info['x-user-id'],
              'X-date': signature_info['x-date'],
              'X-nonce': signature_info['x-nonce'],
              'X-body-sha256': signature_info['x-body-sha256']
            });
            
            // 方式1: 如果认证信息可以通过URL传递
            window.open(`${download_url}?${urlParams.toString()}`, '_blank');
            
            // 方式2: 如果必须通过Header传递，使用隐藏的iframe
            // 这种方式有限制，见下方代码
            
            this.$toast('开始下载');
          } else {
            this.$toast(response.msg || '下载失败');
          }
        } catch (error) {
          this.$toast('下载失败：' + (error.message || error));
          this.$errorLog('index_page/miniDownload', error);
        } finally {
          this.$dialog.loading.hide();
        }
      },
      
      async miniDownload2(fileId, fileName) {
        try {
          // 显示加载状态
          this.$dialog.loading.show();
          
          // 第一步：获取下载地址和认证参数
          const postData = {
            file_data: {
              id: fileId || '1029699'
            }
          };
          
          const response = await createMinioDownload(postData);
          
          if (response.code === 200) {
            const { download_url, signature_info, query_params } = response.data;
            
            // 第二步：使用认证信息下载文件
            const fileBlob = await downloadMinioFile(download_url, signature_info);
            
            // 第三步：触发浏览器下载
            // 获取文件名（优先使用传入的fileName，否则使用query_params中的filename）
            const downloadFileName = fileName || query_params.filename || 'download_file';
            
            // 创建下载链接
            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = downloadFileName;
            
            // 触发下载
            document.body.appendChild(link);
            link.click();
            
            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            this.$toast('下载成功');
          } else {
            this.$toast(response.msg || '下载失败');
          }
        } catch (error) {
          this.$toast('下载失败：' + (error.message || error));
          this.$errorLog('index_page/miniDownload', error);
        } finally {
          // 隐藏加载状态
          this.$dialog.loading.hide();
        }
      },

      async miniUpload(fileInfo) {
        try {
          const postData = {
            file_data: {
              name: fileInfo.title,
              size: fileInfo.size,
              hash: fileInfo.hash,
              type: fileInfo.mime,
              chunk_size: fileInfo.size
            },
            dir_id: this.dirId
          };

          // 调用创建上传任务接口,获取上传URL和认证参数
          const response = await createMinioUpLoad(postData);
          
          if (response.code === 200) {
            const data = response.data;
            return data;
          } else {
            throw new Error(response.msg || '获取上传信息失败');
          }
        } catch (error) {
          this.$errorLog('index_page/miniUpload', error);
          throw error;
        }
      },

      async completeMiniUpload(task_key) {
        try {
          const postData = {
            task_key
          };

          // 调用上传完成任务接口
          const response = await completeMinioUpLoad(postData);
          
          if (response.code === 200) {
            const data = response.data;
            return data;
          } else {
            throw new Error(response.msg || '获取上传信息失败');
          }
        } catch (error) {
          this.$errorLog('index_page/miniUpload', error);
          throw error;
        }
      },

      async completeMiniDownload(task_key) {
        try {
          const postData = {
            task_key
          };

          // 调用下载完成任务接口
          const response = await completeMinioDownload(postData);
          
          if (response.code === 200) {
            const data = response.data;
            return data;
          } else {
            throw new Error(response.msg || '获取下载信息失败');
          }
        } catch (error) {
          this.$errorLog('index_page/miniUpload', error);
          throw error;
        }
      },

      async getUserVip() {
        try {
          var base = await userVip();
          this.userVipInfo = base.data
          this.userVipInfo.vip_info.used_rate = this.userVipInfo.vip_info.used_rate * 100
          if (this.userInfo.vip_status === 1) {
            this.optionFileBtns[0].isVisible = true
          }
        } catch (e) {
          this.$toast(e)
          this.$errorLog('index_page/getUserVip', e)
        }
      },
      changeTab(index) {
        this.dirId = 0;
        this.tabIndex = index
      },
      search() {
        this.changeTab(0)
        // 触发 search 按钮时更新 searchValue，传递到子组件 tabFile
        this.searchValue = this.searchInputValue.trim();
      },
      // 处理文件选择
      selectedFile() {
        this.$refs.fileInput.click();
      },
      async handleFileChange(event) {
        this.$dialog.loading.show()
        for (const file of event.target.files) {
          const title = file.name;
          const size = file.size;
          const mime = file.type;
          const hash = await calculateFileHash(file);
          try{
            const result = await this.getDiskPreUpload(title, hash, size, this.dirId);
            var uploadItem = {
              file,
              logId: result.log_id,
              title,
              size,
              mime,
              hash,
              ossName: result.oss_name,
              quick: result.quick,
              status: 0, // 0: 待上传, 1: 上传中, 2: 上传暂停, 3: 上传完成, 4: 上传失败, 5: 临时暂停等待队列进行
              progress: 0, // 进度初始为 0
              thumb: null,
              checkpoint: null,
              ossClient: null,
              ossClientTime: null,
              time: Date.now(),
              dirId: this.dirId
            };
            /// 添加到队列前，需要
            this.uploadTaskList.push(uploadItem);
            this.isUploadModalVisible = true;
            await this.getDiskStartTask(uploadItem, 1);
          }catch(e){
            this.$toast(e)
            this.$dialog.loading.hide()
            this.$errorLog('index_page/handleFileChange', e)
          }
        }
        this.$refs.fileInput.value = '';
        this.$dialog.loading.hide()
      },
      async getDiskPreUpload(title, hash, size, dirId) {
        try {
          var base = await diskPreUpload({
            title: title,
            dir_id: dirId,
            hash: hash,
            size: size
          });
          return base.data;
        } catch (e) {
          throw e;
        }
      },
      async getDiskStartTask(uploadItem, type) {
        try {
          await diskStartTask({
            'log_id': uploadItem.logId,
            'type': type
          });
        } catch (e) {
          throw e;
        }
      },
      async getDiskUpload(uploadItem, oss_type) {
        try {
          if (oss_type == 1) {
            await diskUpload({
              'title': uploadItem.title,
              'dir_id': uploadItem.dirId,
              'hash': uploadItem.hash,
              'size': uploadItem.size,
              'mime': uploadItem.mime,
              'path': uploadItem.ossName,
              'has_passwd': 0
            });
          }

          uploadItem.status = 3;
          uploadItem.progress = 100;
          this.reloadFiles()
          this.uploadFileTask()
        } catch (e) {
          throw e;
        }
      },
      async uploadFile(uploadItem) {
        try{
          // 设置进度回调
          const onProgress = (percentage) => {
            uploadItem.progress = Math.round(percentage * 100).toFixed(2);
          };
          // 设置进度回调
          const onCheckpoint = (checkpoint) => {
            uploadItem.checkpoint = checkpoint;
          };
          await ossUploadFile(uploadItem, onProgress, onCheckpoint);
        }catch(e){
          throw e;
        }
      },
      // 暂停上传
      async pauseUpload(uploadItem) {
        await ossPauseUpload(uploadItem);
      },
      // 恢复上传
      async resumeUpload(uploadItem) {
        uploadItem.status = 5;
        this.uploadFileTask()
      },

      async uploadFileTask() {
        const uploadingCount = this.uploadTaskList.filter((item) => item.status === 1).length;
        if (uploadingCount < this.userVipInfo.config_info.max_task_upload) {
          const uploadItem = this.uploadTaskList.find((item) => item.status === 0 || item.status === 5);
          if (!uploadItem) return;
          
          uploadItem.status = 1;

          try {
            // 1. 调用 miniUpload 获取任务信息 
            const uploadInfo = await this.miniUpload(uploadItem); 
            if (uploadItem.quick === 1) {
              // 秒传逻辑保持不变
              await this.getDiskUpload(uploadItem);
            } else {
              // 2. 根据 oss_type 选择相应的上传渠道
              if (uploadInfo.oss_type == 1) {
                // 执行阿里云 OSS 上传逻辑
                await this.uploadFile(uploadItem);
              } else if (uploadInfo.oss_type == 2) {
                // 执行 MinIO 分块上传逻辑
                await this.uploadMinioChunkFile(uploadItem, uploadInfo);
              }
              
              // 3. 最终统一绑定到网盘目录并执行完成逻辑
              await this.getDiskUpload(uploadItem, uploadInfo.oss_type);
            }
          } catch (e) {
            console.log('upload error', e);
            if (e.message === 'cancel') {
              uploadItem.status = 2;
              this.uploadFileTask(); // 继续检查队列
            } else {
              uploadItem.status = 4;
            }
            this.$errorLog('index_page/uploadFileTask', e);
          }
        }
      },

      async uploadMinioChunkFile(uploadItem, uploadInfo) {
        try {
          const file = uploadItem.file;
          const uploadId = uploadInfo.upload_id;
          
          const chunkSize = uploadInfo.chunk_size || 5 * 1024 * 1024; 
          const totalChunks = Math.ceil(file.size / chunkSize);

          // 循环上传分块
          for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
            if (uploadItem.status !== 1) throw new Error('cancel'); 

            const start = chunkIndex * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            // ================= 每次上传分块前，动态获取最新的鉴权信息 =================
            console.log(11111)
            const chunkAuthInfo = await this.queryMinioAuth("POST", "/api/minio/api/resumable/chunk");
            console.log('chunkAuthInfo', chunkAuthInfo)
            if (!chunkAuthInfo) {
              throw new Error(`获取分块 ${chunkIndex} 鉴权信息失败`);
            }
            // ============================================================================

            // 调用分块上传接口，替换使用最新获取的 chunkAuthInfo.app_id 和 chunkAuthInfo.encrypted_data
            const chunkRes = await uploadChunk(uploadInfo.upload_domain, {
              uploadId: uploadId,
              taskKey: uploadInfo.task_key,
              fileUuid: uploadInfo.file_uuid,
              uploadDomain: uploadInfo.upload_domain,
              chunkIndex: chunkIndex,
              chunkSize: chunk.size,
            }, chunk, chunkAuthInfo.app_id, chunkAuthInfo.encrypted_data);

            if (!chunkRes.success) throw new Error(chunkRes.msg || `分块 ${chunkIndex} 失败`);

            // 【优化点】：本地计算进度，不再请求接口
            let currentProgress = ((chunkIndex + 1) / totalChunks) * 100;
            // 确保合并校验完成前，进度最多只到 99.99%
            if (currentProgress >= 100) {
              currentProgress = 99.99;
            }
            uploadItem.progress = currentProgress.toFixed(2);
          }

          const authInfo = await this.queryMinioAuth("POST", "/api/minio/api/resumable/complete")
          if (!authInfo) {
            return
          }
          // 通知后端合并文件
          const completeRes = await completeResumableUpload(
            uploadInfo.upload_domain, 
            { 
              uploadId: uploadId,
              fileUuid: uploadInfo.file_uuid
            },
            authInfo.app_id,
            authInfo.encrypted_data
          );

          if (!completeRes.success) throw new Error(completeRes.msg || '合并文件失败');
          
          const authInfo2 = await this.queryMinioAuth("GET", "/api/minio/api/resumable/progress");
          if (!authInfo2) {
            return
          }

          // 合并后拉取最终状态，只有 COMPLETED 才会变为 100%
          const finalProgressRes = await getResumableProgress(
            uploadInfo.upload_domain, 
            { uploadId }, 
            authInfo2.app_id,
            authInfo2.encrypted_data
          );
          if (finalProgressRes.success && finalProgressRes.data.status === 'COMPLETED') {
            uploadItem.progress = 100.00;
            await this.completeMiniUpload(uploadInfo.task_key);
          }
        } catch (e) {
          // 直接抛出异常，由外部调用方(uploadFileTask)统一捕获处理状态
          throw e;
        }
      },

      async uploadMinioChunkFile2(uploadItem, uploadInfo) {
        try {
          const file = uploadItem.file;
          const uploadId = uploadInfo.upload_id;
          
          const chunkSize = uploadInfo.chunk_size || 5 * 1024 * 1024; 
          const totalChunks = Math.ceil(file.size / chunkSize);

          // 循环上传分块
          for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
            if (uploadItem.status !== 1) throw new Error('cancel'); 

            const start = chunkIndex * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            // 调用分块上传接口
            const chunkRes = await uploadChunk(uploadInfo.upload_domain, {
              uploadId: uploadId,
              taskKey: uploadInfo.task_key,
              fileUuid: uploadInfo.file_uuid,
              uploadDomain: uploadInfo.upload_domain,
              chunkIndex: chunkIndex,
              chunkSize: chunk.size,
            }, chunk, uploadInfo.app_id, uploadInfo.encrypted_data);

            if (!chunkRes.success) throw new Error(chunkRes.msg || `分块 ${chunkIndex} 失败`);

            // 【优化点】：本地计算进度，不再请求接口
            let currentProgress = ((chunkIndex + 1) / totalChunks) * 100;
            // 确保合并校验完成前，进度最多只到 99.99%
            if (currentProgress >= 100) {
              currentProgress = 99.99;
            }
            uploadItem.progress = currentProgress.toFixed(2);
          }

          const authInfo = await this.queryMinioAuth("POST", "/api/minio/api/resumable/complete")
          if (!authInfo) {
            return
          }
          // 通知后端合并文件
          const completeRes = await completeResumableUpload(
            uploadInfo.upload_domain, 
            { 
              uploadId: uploadId,
              fileUuid: uploadInfo.file_uuid
            },
            authInfo.app_id,
            authInfo.encrypted_data
          );

          if (!completeRes.success) throw new Error(completeRes.msg || '合并文件失败');
          
          const authInfo2 = await this.queryMinioAuth("GET", "/api/minio/api/resumable/progress");
          if (!authInfo2) {
            return
          }

          // 合并后拉取最终状态，只有 COMPLETED 才会变为 100%
          const finalProgressRes = await getResumableProgress(
            uploadInfo.upload_domain, 
            { uploadId }, 
            authInfo2.app_id,
            authInfo2.encrypted_data
          );
          if (finalProgressRes.success && finalProgressRes.data.status === 'COMPLETED') {
            uploadItem.progress = 100.00;
            await this.completeMiniUpload(uploadInfo.task_key);
          }
        } catch (e) {
          // 直接抛出异常，由外部调用方(uploadFileTask)统一捕获处理状态
          throw e;
        }
      },

      async createDownloadTask(fileId) {
        try {
          
          // 获取下载地址和认证参数
          const postData = {
            file_data: {
              id: fileId || ''
            }
          };
          
          const response = await createMinioDownload(postData);
          
          if (response.code === 200) {
            // const { download_url, signature_info } = response.data;
            return response.data;
          } else {
            this.$toast(response.msg || '下载失败');
          }
        } catch (error) {
          this.$toast('下载失败：' + (error.message || error));
          this.$errorLog('index_page/miniDownload', error);
        }
      },

      async downloadFile() {
        this.$dialog.loading.show();
        let ids = [];
        let dirIds = [];

        // 1. 拆分选中的文件和文件夹
        this.selectionFile.forEach((item) => {
          if (item.is_dir == 1) {
            dirIds.push(item.id);
          } else {
            ids.push(item.id);
          }
        });

        // 2. 如果有文件夹，获取文件夹下所有的子文件 ID
        if (dirIds.length > 0) {
          try {
            const base = await dirFiles({ dir_ids: dirIds.join(',') });
            if (base.data != null) {
              base.data.forEach((item) => {
                ids.push(item.id);
              });
            }
          } catch (e) {
            this.$dialog.loading.hide();
            this.$toast(e);
            this.$errorLog('index_page/downloadFile_dir', e);
            return; // 发生错误停止后续执行
          }
        }

        // 3. 遍历 ID 列表，根据 oss_type 执行不同的下载流程
        await Promise.all(
          ids.map(async (fileId) => {
            try {
              const base = await diskDetail({ file_id: fileId });
              const fileInfo = base.data;
              
              const taskInfo = await this.createDownloadTask(fileId);
              console.log('生成下载任务', taskInfo);

              if (taskInfo.oss_type == 1) {
                // --- 流程 1: 阿里云 OSS 下载 ---
                await ossDownloadFile(fileInfo.path);
              } else if (taskInfo.oss_type == 2) {
                // --- 流程 2: Minio 或其他下载流程 (留白) ---
                console.log('执行 oss_type 为 2 的下载逻辑', fileInfo);
                // --- 流程 2: Minio 下载流程 ---
                // A. 初始化下载，传入 file_uuid 获取 token
                // const initRes = await initMinioDownload(fileInfo.io_domain, fileInfo.file_uuid);
                
                // if (initRes.success && initRes.data.downloadToken) {
                //   const token = initRes.data.downloadToken;
                //   const fileKey = fileInfo.file_uuid;
                  
                //   // 直接拼接完整的接口地址
                //   const fullUrl = `${fileInfo.io_domain}/api/minio/api/download/file?fileKey=${fileKey}&downloadToken=${token}&startPos=-1&speedLimit=-1`;
                  
                //   // 浏览器会自动识别 Content-Type: application/octet-stream 并弹出下载框
                //   window.location.href = fullUrl; 
                // } else {
                //   this.$toast(`文件 ${fileInfo.title} 初始化下载失败`);
                // }

                const token = taskInfo.download_token;
                const fileKey = taskInfo.file_uuid;
                const startPosition = taskInfo.start_position

                // 1. 获取后端返回的鉴权参数
                const appId = taskInfo.app_id;
                // 注意：密文可能包含特殊字符(如+号或=号)，必须使用 encodeURIComponent 编码，否则后端解密会报错！
                const encryptedData = encodeURIComponent(taskInfo.encrypted_data);
                // const encryptedData = taskInfo.encrypted_data;
                
                // 直接拼接完整的接口地址
                const fullUrl = `${taskInfo.download_domain}/api/minio/api/download/file?fileKey=${fileKey}&downloadToken=${token}&startPos=${startPosition}&speedLimit=-1&X-App-Id=${appId}&Encrypted-Data=${encryptedData}`;
                
                // 浏览器会自动识别 Content-Type: application/octet-stream 并弹出下载框
                window.location.href = fullUrl; 
              }

              if (taskInfo && taskInfo.task_key) {
                this.completeMiniDownload(taskInfo.task_key)
              }
              
            } catch (e) {
              this.$toast(`文件 ID ${fileId} 下载失败`);
              this.$errorLog('index_page/downloadFile_detail', e);
              console.log("文件下载失败", e)
            }
          })
        );

        this.$dialog.loading.hide();
      },
      changeDirId(item) {
        this.dirId = item.id
      },
      createDirOpen() {
        this.createVisibleTitle = '新建文件夹'
        this.editFile.id = 0
        this.editFile.name = ''
        this.editFile.isDir = 0;
        this.isOpenCreateVisible = true;
      },
      async submitCreateDir(val) {
        try{
          var base = await diskAddDir({
            pid: this.dirId,
            name: val
          })
          this.reloadFiles()
          this.$toast('新建文件夹成功')
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/submitCreateDir', e)
        }
      },
      selectionList(data) {
        this.selectionFile = data
        
        // 点击下载测试功能
        if (data && data.length > 0) {
          // this.miniDownload2(data[0].id)
        }
        
        if (this.selectionFile.length <= 0) {
          this.optionFileBtns[0].display = true
          this.optionFileBtns[1].display = true
          this.optionFileBtns[2].display = true
          this.optionFileBtns[3].display = true
          this.optionFileBtns[4].display = true
        } else {
          this.optionFileBtns[0].display = false
          this.optionFileBtns[1].display = false
          this.optionFileBtns[2].display = false
          this.optionFileBtns[3].display = false
          this.optionFileBtns[4].display = false
          if (this.selectionFile.length > 1) {
            this.optionFileBtns[3].display = true
          }
        }
      },
      async delFile() {
        var tempArr = [];
        this.selectionFile.forEach((item) => {
          tempArr.push({id: item.id, is_dir: item.is_dir, name: item.title})
        })
        try{
          var base = await diskDelFile({del_data: JSON.stringify(tempArr)});
          this.reloadFiles()
          this.$toast('删除成功');
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/delFile', e)
        }
      },
      cleanSelectedFiles() {
        this.$refs.tabChild.cleanAllSelected()
      },
      rename() {
        if (this.selectionFile.length <= 0) return;
        this.createVisibleTitle = '修改文件名';
        this.editFile.id = this.selectionFile[0].id
        this.editFile.name = this.selectionFile[0].title
        this.editFile.isDir = this.selectionFile[0].is_dir;
        this.isOpenCreateVisible = true;
      },
      async submitRename(data) {
        try{
          await diskRenameFile(data);
          this.reloadFiles()
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/submitRename', e)
        }
      },
      async getDirList() {
        this.isDirListVisible = true
      },
      // async getShareLink() {
      //   var tempArr = [];
      //   this.selectionFile.forEach((item) => {
      //     tempArr.push({id: item.id, is_dir: item.is_dir, name: item.title})
      //   })
      //   try{
      //     var base = await diskCodeCreate({ids: JSON.stringify(tempArr), day: 7, code_type: 2});
      //     await navigator.clipboard.writeText(base.data.link);
      //     this.$toast("复制成功！");
      //     this.$refs.tabChild.cleanAllSelected()
      //   }catch(e){
      //     this.$toast(e)
      //     this.$errorLog('index_page/getShareLink', e)
      //   }
      // },
      
      async getShareLink() {
        var tempArr = [];
        this.selectionFile.forEach((item) => {
          tempArr.push({id: item.id, is_dir: item.is_dir, name: item.title})
        })
        try{
          var base = await diskCodeCreate({ids: JSON.stringify(tempArr), day: 7, code_type: 2});
          
          const success = await this.copyToClipboard(base.data.link);
          
          if (success) {
            this.$toast("复制成功！");
          } else {
            this.$toast("复制失败，请手动复制链接");
            console.log('Share link:', base.data.link);
          }
          
          this.$refs.tabChild.cleanAllSelected()
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/getShareLink', e)
        }
      },

      async copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(text);
            return true;
          } catch (err) {
            console.error('Failed to copy using Clipboard API:', err);
          }
        }
        
        try {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          return successful;
        } catch (err) {
          console.error('Failed to copy using execCommand:', err);
          return false;
        }
      },

      reloadFiles() {
        if (this.tabIndex == 1 || this.tabIndex == 6 || this.tabIndex == 7) return;
        this.$refs.tabChild.formData.page = 1
        this.$refs.tabChild.selectedAll = false;
        setTimeout(() => {
          this.$refs.tabChild.getDiskIndex()
        }, 500)
      },
      async optionFun(type) {
        switch (type){
          case 0:
            if (this.optionFileBtns[0].display) return;
            this.downloadFile();
            break;
          case 1:
            if (this.optionFileBtns[1].display) return;
            this.getShareLink()
            break;
          case 2:
            if (this.optionFileBtns[2].display) return;
            const delDailog = await this.$dialog.notice({
              title: '删除提醒',
              message: '确定要删除选中内容吗？'
            });
            if (delDailog) {
              this.delFile()
            }
            break;
          case 3:
            if (this.optionFileBtns[3].display) return;
            this.rename()
            break;
          default:
            if (this.optionFileBtns[4].display) return;
            this.getDirList()
            break;
        }
      },
      cleanRecycleDisplay(data) {
        this.recycleBtns[2].display = data;
      },
      changeRecycleSelectedData(data) {
        this.recycleSelectedData = data;
        if (this.recycleSelectedData.length > 0) {
          this.recycleBtns[0].display = false;
          this.recycleBtns[1].display = false;
        } else {
          this.recycleBtns[0].display = true;
          this.recycleBtns[1].display = true;
        }
      },
      async reReduction(ids) {
        try{
          await recycleReduction({ids: ids});
          this.recycleSelectedData = [];
          this.changeRecycleSelectedData(this.recycleSelectedData)
          this.$refs.tabChild.formData.page = 1
          this.$refs.tabChild.getRecycleList()
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/reReduction', e)
        }
      },
      async reDels(ids) {
        try{
          await recycleDels({ids: ids});
          if (ids == 'all') {
            this.$toast('已全部清除所有文件');
          } else {
            this.$toast('删除成功');
          }
          this.recycleSelectedData = [];
          this.changeRecycleSelectedData(this.recycleSelectedData)
          this.$refs.tabChild.formData.page = 1
          this.$refs.tabChild.getRecycleList()
        }catch(e){
          this.$toast(e)
          this.$errorLog('index_page/reDels', e)
        }
      },
      async recycleOptionFun(type) {
        switch (type){
          case 0:
            if (this.recycleBtns[0].display) return;
            // const reIds = this.recycleSelectedData.map(item => item.id).join(',');
            var reIds = '';
            var emptyDirs = [];
            for (const item of this.recycleSelectedData) {
              if (item.file_type == 0 && item.file_count == 0) {
                emptyDirs.push(item.name);
              } else {
                if (reIds.length > 0) {
                  reIds += ',';
                }
                reIds += item.id;
              }
            }
            if (reIds == '') {
              if (emptyDirs.length > 0) {
                var tips = emptyDirs.join(',');
                this.$toast(tips + ' 此文件夹内无子文件，请新建文件夹')
              }
              return;
            }
            await this.reReduction(reIds);
            if (emptyDirs.length > 0) {
              var tips = emptyDirs.join(',');
              this.$toast(tips + ' 此文件夹内无子文件，请新建文件夹')
            } else {
              this.$toast('还原成功');
            }
            break;
          case 1:
            if (this.recycleBtns[1].display) return;
            const delDailog = await this.$dialog.notice({
              title: '删除提醒',
              message: '确定要删除选中内容吗？'
            });
            if (delDailog) {
              const delIds = this.recycleSelectedData.map(item => item.id).join(',');
              await this.reDels(delIds);
            }
            break;
          default:
            if (this.recycleBtns[2].display) return;
            const cleanAllDialog = await this.$dialog.notice({
              title: '清空提醒',
              message: '确定清除所有内容吗？'
            });
            if (cleanAllDialog) {
              await this.reDels('all');
            }
            break;
        }
      },
      async logOut() {
        const result = await this.$dialog.notice({
          title: '退出登录',
          message: '退出登录后，无法再上传文件、提取文件、分享文件、确认要退出？',
          cancelText: '取消',
          confirmText: '确定',
        });
        if (result) {
          this.$localStorage.remove(LocalStorageKeys.USER_INFO)
          this.$router.replace('/login');
        }
      },
      showQrCode(event) {
        this.isHovered = true;
        // 获取目标元素的位置
        const rect = event.target.getBoundingClientRect();
        this.position = {
          top: rect.bottom + window.scrollY + 6, // 距离顶部的位置
          left: rect.left + window.scrollX - 140, // 距离左侧的位置
        };
      },
      hideQrCode() {
        this.isHovered = false;
      },
      showOpenMember(event) {
        this.isOpenMemberHovered = true;
        // 获取目标元素的位置
        const rect = event.target.getBoundingClientRect();
        this.openMemberPosition = {
          top: rect.bottom + window.scrollY + 6, // 距离顶部的位置
          left: rect.left + window.scrollX - 200, // 距离左侧的位置
        };
      },
      hideOpenMember() {
        setTimeout(() => {
          this.isOpenMemberHovered = false;
        }, 500);
      },
      showTempOpenMember () {
        this.isOpenMemberHoveredTemp = true;
      },
      hideTempOpenMember () {
        this.isOpenMemberHoveredTemp = false;
      },
      cleanSearchValue() {
        this.searchInputValue = '';
        this.search();
      },
      showOpenMemberDialog() {
        this.isOpenMemberVisible = true;
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    async mounted() {
      const userInfoDe = await rsaDecryptWithPrivateKey(this.$localStorage.get(LocalStorageKeys.USER_INFO));
      this.userInfo = JSON.parse(userInfoDe);
      if (this.$route.query.tabIndex) {
        this.tabIndex = this.$route.query.tabIndex;
      }
      this.getUserVip();
      // this.miniDownload()
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .content {
    background-color: #F8F8F8;
    min-height: 100vh;
    /* 保证背景色覆盖全屏 */
  }

  .head-body {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 121px;

    .head-logo {
      width: 319px;

      img {
        padding-left: 120px;
        width: 103px;
        height: 24px;
      }
    }

    .head-search-body {
      display: flex;
      align-items: center;
      justify-content: center;

      .head-search {
        display: flex;
        align-items: center;
        background-color: white;
        padding: 0 10px;
        height: 44px;
        border-radius: 14px;
        width: 323px;

        .search-ic {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 6px;

          img {
            width: 24px;
            height: 24px;
          }
        }

        .search-text {
          flex: 1;
          height: 100%;
          display: flex;
          align-items: center;
          input {
            width: 100%;
            height: 100%;
          }
          .ic-clean:hover {
            cursor: pointer;
          }
          .ic-clean {
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            img {
              width: 24px;
              height: 24px;
            }
          }
        }
      }
      .head-download-body:hover {
        cursor: pointer;
      }
      .head-download-body {
        margin-left: 10px;
        width: 60px;
        height: 40px;
        background-color: white;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .head-open-member-body:hover {
        cursor: pointer;
      }
      .head-open-member-body {
        margin-left: 10px;
        position: relative;
        width: 112px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 14px;
        font-size: 16px;
        color: #713801;
        font-weight: bold;
        background: linear-gradient( 315deg, #FFD9B5 0%, #FEF7E6 41%, #FFD1BE 100%);
        border-radius: 14px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 14px;
          padding: 1px; /* 控制边框粗细 */
          background: linear-gradient(to right, #FFC696, #FFD2A8);
          -webkit-mask: 
            linear-gradient(#fff 0 0) content-box, 
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          pointer-events: none;
        }
        .head-open-member-bar {
          position: absolute;
          top: -12px;
          right: 0;
          width: 76px;
          height: 20px;
          background: linear-gradient( 270deg, #FF8140 0%, #FF1212 100%);
          border-radius: 6px 6px 0px 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: white;
          font-weight: bold;
        }
      }
      .open-member-hover-display {
        position: absolute;
        width: 314px;
        height: 400px;
        background-color: white;
        border-radius: 20px;
        border: .5px solid #CCCCCC;
        .open-member-body {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 100%;
          background-color: white;
          border-radius: 20px;
          .open-member-head {
            width: 100%;
            height: 90px;
            background-size: 314px 90px;
            // background-image: url('../assets/member_vip_bg_n.png');
            &.bg-normal {
              background-image: url('../assets/member_vip_bg_n.png');
            }
            
            &.bg-active {
              background-image: url('../assets/member_vip_bg_y.png');
            }
            .open-member-head-msg {
              display: flex;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
              padding: 22px 0 0 24px;
              .open-member-head-name {
                width: 66px;
                height: 16px;
                img {
                  width: 66px;
                  height: 16px;
                }
              }
              .open-member-head-tips {
                margin-top: 6px;
                font-size: 13px;
                color: rgba(34, 34, 34, 0.40);
                font-weight: bold;
              }
              .tips-vip {
                color: rgba(113, 56, 1, 1);
              }
            }
          }
          .open-member-title {
            margin: 6px 0 18px 0;
            font-size: 15px;
            font-weight: bold;
            background: linear-gradient(to right, rgba(192, 94, 0, 1), rgba(113, 56, 1, 1), rgba(113, 56, 1, 1));
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .member-options-grid {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            gap: 8px;
            padding: 0 26px;
            justify-content: space-between;
            .option-item {
              display: flex;
              align-items: center;
              gap: 14px;
              border-radius: 8px;
              width: 115px;
              
              .option-icon {
                width: 28px;
                height: 28px;
                
                img {
                  width: 28px;
                  height: 28px;
                  object-fit: contain;
                }
              }
              
              .option-title {
                font-size: 12px;
                color: rgba(51, 51, 51, 1);
                font-weight: bold;
              }
            }
          }
          .open-member-body-btn:hover {
            cursor: pointer;
          }
          .open-member-body-btn {
            position: relative;
            margin-bottom: 23px;
            width: 266px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient( 315deg, #FFD9B5 0%, #FEF7E6 41%, #FFD1BE 100%);
            border-radius: 10px;
            font-size: 16px;
            color: rgba(113, 56, 1, 1);
            font-weight: bold;
            // 添加伪元素实现渐变边框
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border-radius: 10px;
              padding: 1px; // 控制边框粗细
              background: linear-gradient(to right, rgba(255, 210, 168, 1), rgba(255, 198, 150, 1));
              -webkit-mask: 
                linear-gradient(#fff 0 0) content-box, 
                linear-gradient(#fff 0 0);
              -webkit-mask-composite: xor;
              mask-composite: exclude;
              pointer-events: none; // 确保不影响按钮点击
            }
          }
        }
      }
      .hover-display {
        position: absolute;
        width: 200px;
        height: 230px;
        background-color: white;
        border-radius: 20px;
        border: .5px solid #CCCCCC;
        .download-body {
          padding: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .title {
            font-size: 20px;
          }
          .app-name {
            margin-bottom: 15px;
            color: #4A83FF;
            font-size: 13px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .content-body {
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 90px - 30px);
    padding-right: 97px;

    .left-tab {
      width: 319px;
      display: flex;
      flex-direction: column;
      .user-info {
        padding-left: 116px;
        padding-right: 29px;

        .user-info-body {
          border-bottom: 1px solid #EEEEEE;
          height: 78px;
          display: flex;
          align-items: center;
          padding-left: 4px;

          .user-img {
            width: 40px;
            height: 40px;
            margin-right: 10px;

            img {
              width: 40px;
              height: 40px;
              border-radius: 40px;
            }
          }

          .user-msg-body {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 118px;
            height: 47px;

            .user-name-body {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .user-name {
                font-size: 14px;
                font-weight: bold;
                color: #713801;
                flex: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .user-vip {
                width: 28px;
                height: 15px;
                display: flex;
                align-items: center;
                align-items: center;

                img {
                  width: 28px;
                  height: 15px;
                }
              }
            }

            .progress-container {
              width: 100%;
              max-width: 118px;

              .progress-bar {
                width: 100%;
                background-color: rgba(0, 0, 0, 0.08);
                border-radius: 5px;
                height: 4px;
                overflow: hidden;

                .progress {
                  height: 100%;
                  background-color: #4A83FF;
                  transition: width 0.3s ease;
                  border-radius: 8px 0 0 8px;
                }
              }
            }

            .user-capacity-body {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .user-capacity {
                font-size: 10px;
                font-weight: bold;
                color: #333333;
                flex: 1;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow-x: hidden;
              }

              .see-capacity {
                font-size: 10px;
                color: #4A83FF;
              }

              .see-capacity:hover {
                cursor: pointer;
              }
            }
          }
        }
      }

      .tab-body {
        padding-left: 120px;
        margin-top: 10px;
        flex: 1;
        .tab-item {
          width: 179px;
          height: 40px;
          display: flex;
          align-items: center;
          border-radius: 8px;
          font-size: 13px;
          color: #666666;
          font-weight: bold;

          .item-label {
            margin-left: 10px;
          }

          .item-icon {
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 12px;

            img {
              width: 20px;
              height: 20px;
            }
          }
        }

        .tab-item:hover {
          cursor: pointer;
        }

        .item-selected {
          background-color: white;
          color: #4A83FF;
        }
      }
      .log-out {
        padding-left: 120px;
        margin-bottom: 32px;
        .log-out-btn:hover {
          cursor: pointer;
        }
        .log-out-btn {
          background-color: white;
          width: 179px;
          height: 40px;
          color: #4A83FF;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          font-size: 13px;
          font-weight: bold;
        }
      }
    }

    .body {
      flex: 1;
      height: 100%;
      background-color: white;
      border-radius: 24px;

      /* padding: 0 24px; */
      .body-head-content {
        padding: 0 24px;

        .body-head {
          border-bottom: 1px solid #EEEEEE;
          height: 79px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .option-btns {
            display: flex;
            align-items: center;
            align-items: center;
            height: 100%;

            .btn {
              width: 120px;
              height: 36px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
              font-weight: bold;
            }

            .btn:hover {
              cursor: pointer;
            }

            .add {
              background-color: #4A83FF;
              color: white;
              margin-right: 10px;
            }

            .create {
              color: #000;
              border: 1px solid #000;
            }
          }

          .option-file-btns {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(204, 204, 204, );
            height: 36px;
            border-radius: 10px;
            font-weight: bold;
            font-size: 13px;

            .file-btn {
              padding: 0 11px;
              border-right: 1px solid rgba(204, 204, 204, 1);
              height: 100%;
              display: flex;
              align-items: center;
              transition: color 0.2s ease;
            }

            .file-btn:hover {
              cursor: pointer;
            }

            .last-file-btn {
              border: none;
            }
            .btn-display {
              color: rgba(0, 0, 0, 0.2);
            }
          }
        }
      }

      .tab-content {
        height: calc(100vh - 169px); // 这里根据父级的布局调整
        /* overflow-y: auto; */
      }
    }
  }
  .copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    height: 30px;
    color: #999;
    a {
      margin-left: 4px;
      color: #999;
      text-decoration: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/content/index_page.vue